/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} How_We_Work_Log_Entry_1_BodyInputs */

const en_how_we_work_log_entry_1_body = /** @type {(inputs: How_We_Work_Log_Entry_1_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A new service or an updated process.`)
};

const lv_how_we_work_log_entry_1_body = /** @type {(inputs: How_We_Work_Log_Entry_1_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jauns pakalpojums vai atjaunots process.`)
};

/**
* | output |
* | --- |
* | "A new service or an updated process." |
*
* @param {How_We_Work_Log_Entry_1_BodyInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const how_we_work_log_entry_1_body = /** @type {((inputs?: How_We_Work_Log_Entry_1_BodyInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<How_We_Work_Log_Entry_1_BodyInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_how_we_work_log_entry_1_body(inputs)
	return en_how_we_work_log_entry_1_body(inputs)
});